export default "/kiban/_next/static/images/manual-fb06bc4edfdf3784fc47a187496f10e1.png";